import React from "react";
import PropTypes from "prop-types";
import Loadable from "react-loading-overlay";

export default class CommonLoadable extends React.Component {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    text: PropTypes.string,
    spinnerSize: PropTypes.string,
    background: PropTypes.string
  };

  render() {
    return (
      <Loadable
        active={this.props.active}
        spinner
        animate
        text={this.props.text}
        spinnerSize={this.props.spinnerSize}
        background={
          this.props.background
            ? this.props.background
            : "rgba(244, 245, 248, 0.75)"
        }
        color="rgba(1, 1, 1, 0.75)"
      >
        {this.props.children}
      </Loadable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/_Shared/commonLoadable.js